import { Controller } from '@hotwired/stimulus'

// Shows a bottom action bar only after the page has been scrolled
// past roughly the midpoint - avoids a permanently fixed footer card.
export default class extends Controller {
  static targets = ['bar']
  static values = {
    threshold: { type: Number, default: 0.45 }
  }

  connect () {
    this.onScroll = () => this.update()
    this.onResize = () => this.update()
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onResize, { passive: true })
    this.update()
  }

  disconnect () {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  }

  update () {
    if (!this.hasBarTarget) return

    const doc = document.documentElement
    const scrollable = Math.max(doc.scrollHeight - window.innerHeight, 1)
    const progress = window.scrollY / scrollable
    const visible = progress >= this.thresholdValue

    this.barTarget.classList.toggle('translate-y-full', !visible)
    this.barTarget.classList.toggle('opacity-0', !visible)
    this.barTarget.classList.toggle('pointer-events-none', !visible)
    this.barTarget.setAttribute('aria-hidden', visible ? 'false' : 'true')
  }
}
